<template>
  <div class="pagination">
    <div class="indicator">
      <button
          :disabled="paginator.current_page < 1"
          @click="prevPage"
          class="btn-transparent"
      >
        <ChevronLeftIcon></ChevronLeftIcon>
      </button>

      <button
        :disabled="page === spacer"
        @click="goToPage(page)"
        v-for="page in pageRange"
        :key="page"
        class="btn-transparent"
        :class="{ 'active' : page === paginator.current_page, 'no-animation': page === spacer } "
      >
        {{ page }}
      </button>
      <button
          :disabled="paginator.current_page > paginator.total_pages - 1"
          @click="nextPage"
          class="btn-transparent"
      >
        <ChevronRightIcon></ChevronRightIcon>
      </button>
    </div>
    <div v-if="showPerPage" class="per-page">
      Per pagina
      <dd-select v-model="perPage" style="width: 70px;">
        <a-select-option v-bind:value="10">10</a-select-option>
        <a-select-option v-bind:value="15">15</a-select-option>
        <a-select-option v-bind:value="30">30</a-select-option>
      </dd-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "DdPagination",
  emits: ['go-to-page', 'per-page'],
  props: {
    paginator: {
      required: true,
      type: Object,
    },
    showPerPage:{
      type: Boolean,
      required: false,
      default: true
    },
    compact: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      perPage: 15,
      spacer: '...',
    }
  },
  watch: {
    perPage() {
      this.$emit('per-page', this.perPage);
    }
  },
  methods: {
    goToPage(page) {
      this.$emit('go-to-page', page);
    },
    prevPage() {
      if (this.paginator.current_page - 1 >= 1)  {
        this.$emit('go-to-page', this.paginator.current_page-1);
      }
    },
    nextPage() {
      if (this.paginator.current_page + 1 <= this.paginator.total_pages) {
        this.$emit('go-to-page', this.paginator.current_page+1);
      }
    },
    compactRange(current, total){
      if (total <= 5) {

        return total;

      } else {

        if (current <= 3){

          return [1, 2, 3, 4, total];

        } else if (current > total - 3){

          return [1, total - 3, total - 2, total - 1, total];

        } else {

          const midUnderCurrent = Math.floor(current * 0.5);
          const midAboveCurrent = current + Math.floor((total - current) * 0.5);
          return [1, midUnderCurrent, current, midAboveCurrent, total];

        }
      }
    },
    fullRange(current, total){
      if (total <= 12 ) {

        return total;

      } else {

        if ( current < 6){
          return [1, 2, 3, 4, 5, 6, 7, 8, this.spacer, total - 2, total - 1, total];
        } else if ( current > total - 6){
          return [1, 2, 3, this.spacer, total - 7, total - 6, total - 5, total - 4, total - 3, total - 2, total - 1, total];
        } else {
          return [1, 2, 3, this.spacer, current - 2, current - 1, current, current + 1, current + 2, this.spacer, total - 2, total - 1, total];
        }

      }
    }
  },
  computed: {
    links() {
      return this.paginator.links;
    },
    pageRange() {
      const current = this.paginator.current_page, total = this.paginator.total_pages;
      if ( this.compact ){

        return this.compactRange(current, total);

      } else {

        return this.fullRange(current, total);

      }
    }
  },

}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.pagination {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 $spacing-lg;
  max-height: $spacing-xl;
  position: relative;

  .indicator {
    z-index: 1;
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    button {
      background-color: white;
      color: $brand-primary;
      border-radius: $border-radius-base;
      width: $spacing-xl;
      height: $spacing-xl;
      display: flex;
      place-content: center;
      align-items: center;
    }
    button.active {
      background-color: $brand-primary;
      color: white;
    }
    button:not(.active):active {
      background-color: $color-primary-transparent !important;
    }
    button.no-animation {
      cursor: default !important;
    }
  }

}
</style>
<style lang="scss" >
@import "~@/_default.scss";

.card.wide-content {
  .pagination {
    padding: 0 $spacing-lg;
  }
}
.pagination {
  .per-page {
    position: absolute;
    width: 100%;
    right: 0;
    margin-right: $spacing-lg;
    color: $brand-primary;
    display: flex;
    gap: $spacing-xs;
    align-items: center;
    justify-content: flex-end;

    .ant-select-selection {
      height: 30px;
      display: flex;
      align-items: center;
    }
  }
}
</style>
